module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/lauren-mcglamery-abe32babfa9150db1fd4699cdf28b8d0.jpg";